<template>
  <div class="app-container">
    <div class="warpper">
      <el-form ref="searchForm" :inline="true" :model="searchCondition">
        <el-form-item label="药品名称">
          <el-input
            v-model="searchCondition.name"
            placeholder="药品名称"
            clearable
          />
        </el-form-item>
        <el-form-item label="批准文号">
          <el-input
            v-model="searchCondition.approvalCode"
            placeholder="批准文号"
            clearable
          />
        </el-form-item>
        <el-form-item label="生产厂商">
          <el-input
            v-model="searchCondition.companyCame"
            placeholder="生产厂商"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList">查询</el-button>
          <el-button @click="resetField()">重置</el-button>
        </el-form-item>
      </el-form>
      <el-tabs v-model="searchCondition.status" @tab-click="getList">
        <el-tab-pane
          :label="`全部（${countNum.all || 0}）`"
          name="0"
        />
        <el-tab-pane :label="`已上架（${countNum.putaway || 0}）`" name="1" />
        <el-tab-pane :label="`已下架（${countNum.soldOut || 0}）`" name="2" />
        <el-tab-pane :label="`未上架（${countNum.unPutaway || 0}）`" name="3" />
      </el-tabs>
      <el-table
        v-loading="tableLoading"
        :data="tableData"
        style="width: 100%"
        border
      >
        <el-table-column prop="drugCode" label="药品编码" align="center" />
        <el-table-column prop="name" label="药品名称" align="center" />
        <el-table-column prop="approvalCode" label="批准文号" align="center" />
        <el-table-column
          prop="actualSpecs"
          label="规格"
          align="center"
          width="130"
        />
        <el-table-column prop="packUnit" label="包装单位" align="center" />
        <el-table-column prop="actualDosage" label="剂型号" align="center" />
        <el-table-column prop="drugType" label="药品类型" align="center">
          <template slot-scope="{ row }">
            {{ DRUG_TYPE[row.type] }}
          </template>
        </el-table-column>
        <el-table-column prop="companyName" label="生产厂商" align="center" />
        <!-- <el-table-column prop="type" label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'warning'">{{
              UP_STATUS[row.status]
            }}</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column prop="type" label="备案状态" align="center">
          <template slot-scope="{ row }">
            <el-tag
              :type="row.uploadStatus === 10602 ? 'success' : 'warning'"
              >{{ UPLOAD_STATUS[row.uploadStatus] }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="type" label="是否处方药" align="center">
          <template slot-scope="{ row }">
            {{ PRESCRIPTTION_DRUG_TYPE[row.drugType] }}
          </template>
        </el-table-column>
        <el-table-column prop="gmtCreate" label="创建时间" align="center" />
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.status === 2 || row.status === 3"
              type="text"
              size="small"
              @click="onUpDrug(row)"
              >上架</el-button
            >
            <el-button v-if="row.status === 1" type="text" size="small" @click="onDownDrug(row)"
              >下架</el-button
            >
            <el-button
              v-if="row.uploadStatus !== 10602"
              type="text"
              size="small"
              @click="onPutDrug(row)"
              >备案</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :current-page="searchCondition.currentPage"
          :page-size="searchCondition.pageSize"
          :total="totalCount"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
      <el-dialog
        :title="isEdit === 2 ? '下架药品页面' : '上架药品页面'"
        :visible.sync="upDrugFlag"
      >
        <UpDrug
          v-if="upDrugFlag"
          :is-edit="isEdit"
          :item-list="itemList"
          @closeForm="closeForm"
          @refresh="resetField"
        />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { drugsList, setSoldOut, uploadDrugCatalogue, listCount } from "@/api/doctor.js";
import {
  PRESCRIPTTION_DRUG_TYPE,
  DRUG_TYPE,
  UPLOAD_STATUS,
  UP_STATUS,
} from "@/utils/eum";
import UpDrug from "./components/upDrug";

export default {
  name: "DrugList",
  components: { UpDrug },
  data() {
    return {
      PRESCRIPTTION_DRUG_TYPE,
      DRUG_TYPE,
      UPLOAD_STATUS,
      UP_STATUS,
      upDrugFlag: false,
      tableLoading: false,
      searchCondition: {
        drugstoreId: 1,
        currentPage: 1,
        pageSize: 10,
        name: "",
        approvalCode: "",
        companyCame: "",
        status: 0,
      },
      totalCount: 0,
      tableData: [],
      isEdit: 0,
      itemList: [],
      countNum: {
        countStatus1: 0,
        countStatus2: 0,
      },
      prescriptionHtml: "",
    };
  },
  created() {
    this.getList();
    this.getCount();
  },
  methods: {
    async getList() {
      this.tableLoading = true;
      const res = await drugsList(this.searchCondition);
      this.tableData = res.data.records || [];
      this.totalCount = parseInt(res.data.totalCount);
      this.tableLoading = false;
    },
    async getCount() {
      const params = {
        storeId: 1, // 药店id
      };
      const res = await listCount(params);
      this.countNum = res.data;
    },
    handleCurrentChange(val) {
      this.searchCondition.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.searchCondition.pageSize = val;
      this.getList();
    },
    // 重置
    resetField() {
      this.searchCondition.name = "";
      this.searchCondition.approvalCode = "";
      this.searchCondition.companyCame = "";
      this.upDrugFlag = false;
      this.getList();
    },
    // 上架
    async onUpDrug(item) {
      this.upDrugFlag = true;
      this.isEdit = 1;
      this.itemList = item;
    },
    // 下架
    async onDownDrug(item) {
      const params = {
        storeId: 1, // 药店id
        drugId: item.id,
      };
      const res = await setSoldOut(params);
      if (res.code === 1) {
        this.$message({
          message: "下架成功",
          type: "success",
        });
      }
      this.getList();
    },
    // 备案
    async onPutDrug(item) {
      const params = {
        storeId: 1, // 药店id
        id: item.id,
      };
      const res = await uploadDrugCatalogue(params);
      if (res.code === 1) {
        this.$message({
          message: "备案成功",
          type: "success",
        });
      }
      this.getList();
    },
    // 关闭弹窗通知
    closeForm() {
      this.upDrugFlag = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  height: 100%;
  min-width: 1200px;
  margin-top: 15px;

  .warpper {
    width: 95%;
    margin: auto;
  }
}
.el-table__body /deep/ .el-table__empty-text {
  width: 25% !important;
}
.block {
  margin-top: 10px;
}
.el-tabs {
  margin-bottom: 0;
}
</style>
